import { useCallback } from "react";

import { toastActions } from "./actions";
import { useDelayedActionToast } from "./context";
import { ShowToastAction } from "./types";

/**
 * Convenience hook for easier toast management
 * Provides simple methods to show, hide, and update toast
 */
export const useDelayedActionToastActions = () => {
    const { dispatch } = useDelayedActionToast();

    const showToast = useCallback(
        (payload: ShowToastAction["payload"]) => {
            if (!dispatch) {
                if (process.env.NODE_ENV !== "production") {
                    throw new Error(
                        "useDelayedActionToastActions must be used within a DelayedActionToastProvider"
                    );
                }
                return;
            }
            dispatch(toastActions.showToast(payload));
        },
        [dispatch]
    );

    const hideToast = useCallback(() => {
        if (!dispatch) {
            if (process.env.NODE_ENV !== "production") {
                throw new Error(
                    "useDelayedActionToastActions must be used within a DelayedActionToastProvider"
                );
            }
            return;
        }
        dispatch(toastActions.hideToast());
    }, [dispatch]);

    return {
        showToast,
        hideToast,
    };
};
